const qdAminCommon = window.QD_ADMIN_COMMON || {};
const { envConfig, LoginCommon, data, showLoginPanel } = qdAminCommon;
const { protocolDomain = {}, logout } = LoginCommon || {};
const { isPrivate } = envConfig || {};

export { isPrivate, envConfig, protocolDomain, logout, data as commonData, showLoginPanel  };
